import { useQuery } from '@tanstack/react-query';
import { validatedApi } from '../../../lib/api/validated-client';
import type { PaginatedVenuesResponse } from '@lov/shared';
import type { VenueTypeCode } from '../constants/venueTypes';

interface FeaturedVenuesParams {
  venueType?: VenueTypeCode;
  limit?: number;
  cityId?: string;
}

export function useFeaturedVenues(params: FeaturedVenuesParams = {}) {
  const { venueType, limit = 12, cityId } = params;

  return useQuery<PaginatedVenuesResponse>({
    queryKey: ['venues', 'featured', venueType, limit, cityId],
    queryFn: async () => {
      const queryParams: Record<string, string | number> = {
        sortBy: 'popularity',
        limit,
      };

      if (venueType) {
        queryParams.venueType = venueType;
      }

      if (cityId) {
        queryParams.cityId = cityId;
      }

      return validatedApi.get('/venues', { params: queryParams });
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
